import React from 'react';
import MarkdownViewer from './MarkdownViewer';

function ServiceLevelDisclaimer() {
  return (
    <MarkdownViewer
      title="Service Level Disclaimer"
      fileName="SERVICE_LEVEL_DISCLAIMER.md"
    />
  );
}

export default ServiceLevelDisclaimer;
